<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/Arrow Ios Right"
      xmlns="http://www.w3.org/2000/svg"
      width="7.188"
      height="14.376"
      viewBox="0 0 7.188 14.376"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Arrow-ios-right"
        d="M1.026,14.376a1.027,1.027,0,0,1-.789-1.684l4.6-5.515L.4,1.671A1.027,1.027,0,0,1,2,.383L6.961,6.544a1.027,1.027,0,0,1-.011,1.3L1.816,14.006a1.026,1.026,0,0,1-.79.37"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowRightIcon extends Vue {}
</script>

<style>
</style>
